import {Component, EventEmitter, Input, Output} from '@angular/core';
import Venue from '../../../smoothr-web-app-core/models/Venue';
import {WorkingHoursModalComponent} from '../working-hours-modal/working-hours-modal.component';
import {ModalController} from '@ionic/angular';
import {PreorderType, PreorderTypeArray} from '../../../smoothr-web-app-core/enums/PreorderType';
import moment, {Moment} from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {environment} from 'src/environments/environment';
import {getSlots, isVenueOpen, venueAcceptsOrders} from '../../../smoothr-web-app-core/utils/utils';
import {OrderType} from 'src/smoothr-web-app-core/enums/OrderType';
import Address from 'src/smoothr-web-app-core/models/Address';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {ValidationUtils} from 'src/smoothr-web-app-core/utils/validation-utils';

@Component({
	selector: 'app-venue-suggestion',
	templateUrl: './venue-suggestion.component.html',
	styleUrls: ['venue-suggestion.component.scss']
})
export class VenueSuggestionComponent {
	private _longDays = [
		this.translate.instant('weekday.monday'),
		this.translate.instant('weekday.tuesday'),
		this.translate.instant('weekday.wednesday'),
		this.translate.instant('weekday.thursday'),
		this.translate.instant('weekday.friday'),
		this.translate.instant('weekday.saturday'),
		this.translate.instant('weekday.sunday')
	];
	environment = environment;
	isVenueOpen = isVenueOpen;
	@Input() type: PreorderType;
	@Input() isShopView = false;
	@Input() isOpenMap = false;
	@Output() venuePick = new EventEmitter<{venue: Venue; type: PreorderType}>();
	@Output() deleteVenue = new EventEmitter<void>();
	@Output() venueModalOpen = new EventEmitter<void>();
	@Input() address: Address;
	closeTodayHours = '';
	pt = PreorderType;
	overridePostalDelivery = false;
	acceptsDelivery = false;
	firstDeliveryTime: string = null;
	acceptsInside = false;
	firstInsideTime: string = null;
	acceptsTakeaway = false;
	firstTakeAwayTime: string = null;
	@Input()
	selected = false;
	ptArray = PreorderTypeArray.filter(it => {
		return it !== PreorderType.PARK_COLLECT;
	});
	distance;
	openTodayHours = '';
	isVenueOpenUtils = isVenueOpen;
	constructor(
		private modalCtrl: ModalController,
		private translate: TranslateService,
		private repository: RepositoryService
	) {}

	private _venue: Venue;

	get venue(): Venue {
		return this._venue;
	}

	@Input()
	set venue(venue: Venue) {
		this._venue = venue;
		this.acceptsDelivery = false;
		this.acceptsTakeaway = false;
		this.acceptsInside = false;
		this.firstDeliveryTime = null;
		this.firstTakeAwayTime = null;
		this.firstInsideTime = null;
		if (venue === undefined || venue === null) {
			return;
		}
		this.acceptsTakeaway = true;
		getSlots(venue, OrderType.PREORDER, PreorderType.TAKE_AWAY, null, 0, false, 5).then(slots => {
			this.acceptsTakeaway = slots.length > 0 && venueAcceptsOrders(venue, PreorderType.TAKE_AWAY);
		});
		this.acceptsDelivery = false;
		this.firstDeliveryTime = null;
		// getSlots(venue, OrderType.PREORDER, PreorderType.DELIVERY, null, 0, false, 5).then(slots => {
		// 	this.acceptsDelivery =
		// 		slots.length > 0 && venueAcceptsOrders(venue, PreorderType.DELIVERY, this.overridePostalDelivery);
		// 	if (this.acceptsDelivery) {
		// 		this.firstDeliveryTime = this.timeToText(venue, moment(slots[0].time));
		// 		this.acceptsDelivery = true;
		// 	}
		// });
		getSlots(venue, OrderType.PREORDER, PreorderType.INSIDE, null, 0, false, 5).then(slots => {
			this.acceptsInside =
				slots.length > 0 && venueAcceptsOrders(venue, PreorderType.INSIDE, this.overridePostalDelivery);
			if (this.acceptsInside) {
				this.firstInsideTime = this.timeToText(venue, moment(slots[0].time));
			}
		});
		this.calculateDistance();
		this.acceptsDelivery = this.checkDeliveryEnabled(this.repository._address);
	}
	//check if delivery is enabled
	checkDeliveryEnabled(address: Address): boolean {
		try {
			if (address) {
				const addressValidationResult = ValidationUtils.validateAddress(address, true);
				if (addressValidationResult) {
					return false;
				}
				const delivers =
					(this.venue.deliveryByRadius &&
						this.getDistanceBetweenTwoPoints(
							{
								lat: address.lat,
								lon: address.lng
							},
							{
								lat: this.venue.location.coordinates[1],
								lon: this.venue.location.coordinates[0]
							}
						) <= this.venue.deliveryRadius) ||
					(this.venue.isPostalDelivery && this.venue.deliveryPostalCodes.indexOf(address.postalCode));
				if (!delivers) {
					return false;
				}
				return true;
			} else {
				return false;
			}
		} catch (e) {
			return false;
		}
	}
	selectVenue(venue: Venue, type: PreorderType) {
		if (!this.accepts(type)) {
			return;
		}
		this.venuePick.emit({venue, type});
	}

	accepts(type: PreorderType): boolean {
		switch (type) {
			case PreorderType.DELIVERY:
				return this.acceptsDelivery;
			case PreorderType.TAKE_AWAY:
				return this.acceptsTakeaway;
			case PreorderType.INSIDE:
				return this.acceptsInside;

			default:
				return false;
		}
	}

	async openModal(venue: Venue) {
		await WorkingHoursModalComponent.show(this.modalCtrl, venue, this.type);
	}

	timeToText(venue: Venue, time: Moment | null) {
		if (time && venue.slot) {
			const now = moment().add(
				Math.abs((moment().minutes() % venue.slot.interval) - venue.slot.interval) % venue.slot.interval,
				'minutes'
			);
			const roundedTime = time.add(
				Math.abs((time.minutes() % venue.slot.interval) - venue.slot.interval) % venue.slot.interval,
				'minutes'
			);
			const relevantTime = now.isAfter(roundedTime) ? now : roundedTime;
			const isToday = now.dayOfYear() === relevantTime.dayOfYear() && now.year() === relevantTime.year();
			return (isToday ? '' : this.translate.instant('venue_suggestion.tomorrow') + ' ') + relevantTime.format('HH:mm');
		} else {
			return null;
		}
	}
	isVenueOpenFunc(venue: Venue) {
		return this.isVenueOpen(venue)
			? this.translate.instant('venue_suggestion.open')
			: this.translate.instant('venue_suggestion.close');
	}

	deleteSelectedVenue($event) {
		if (this.isShopView) {
			this.selected = false;
		}
		this.deleteVenue.emit();

		$event.stopPropagation();
	}
	calculateDistance() {
		const day = moment().weekday();
		this.closeTodayHours = this.venue?.openingHours[day]?.closedAt;
		this.distance = Math.round(
			this.getDistanceBetweenTwoPoints(
				{
					lat: this.venue?.location?.coordinates[1],
					lon: this.venue?.location?.coordinates[0]
				},
				{
					lat: this.repository._address?.lat,
					lon: this.repository._address?.lng
				}
			)
		);
	}
	getDistanceBetweenTwoPoints(cord1: {lat: number; lon: number}, cord2: {lat: number; lon: number}) {
		if (cord1.lat == cord2.lat && cord1.lon == cord2.lon) {
			return 0;
		}

		const radlat1 = (Math.PI * cord1.lat) / 180;
		const radlat2 = (Math.PI * cord2.lat) / 180;

		const theta = cord1.lon - cord2.lon;
		const radtheta = (Math.PI * theta) / 180;

		let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

		if (dist > 1) {
			dist = 1;
		}

		dist = Math.acos(dist);
		dist = (dist * 180) / Math.PI;
		dist = dist * 60 * 1.1515;
		dist = dist * 1.609344; //convert miles to km

		return dist;
	}
	isVenueOpenText(venue: Venue) {
		return this.isVenueOpenUtils(venue)
			? this.translate.instant('venue_suggestion.open')
			: this.translate.instant('venue_suggestion.close');
	}

	venueOpen() {
		// if (this.isShopView) {
		this.selected = true;
		// }
	}

	venueOpenMod() {
		if (!this.isShopView) {
			this.venueModalOpen.emit();
		}
	}
	dayWhenOpen() {
		let day = moment().weekday();
		if (+this.venue?.openingHours[day]?.closedAt.split(':')[0] < new Date().getHours()) {
			day++;
		}
		this.openTodayHours = this.venue?.openingHours[day]?.openedAt;

		return this._longDays[day];
	}
}
